export const EMPTY_EMAIL_ERROR = 'Please Enter Email ';
export const INVALID_EMAIL_ERROR = 'please Enter A Valid Email ';
export const PASSWORD_ERROR = 'Please Enter Password ';
export const USERNAME_ERROR = 'Please Enter Username ';
export const FULLNAME_ERROR = 'Please Enter Full Name ';
export const INVALID_ERROR = 'Number Not Allow ';
export const CONTACT_ERROR = 'Please Enter Mobile Number ';
export const INVALID_CONTACT_ERROR = 'Please Enter Valid Mobile Number ';
export const APIKEY_ERROR = 'Please Enter APIKey ';
export const APIID_ERROR = 'Please Enter APIID ';
export const APISECRET_ERROR = 'Please Enter API Secret ';
export const BROKER_ERROR = 'Please Select Broker ';
export const LICENCE_TYPE_ERROR = 'Please Enter Licence Type ';
export const LICENCE_ERROR = 'Please Enter Licence Month';
export const QUANTITYSELECT_ERROR = 'Please Select Quantity Selection';
export const GROUPSELECT_ERROR = 'Please Select Group Service';

// export const PER_TRADE_ERROR = 'Please Enter Per Trade Fund Value ';
// export const PER_TRADE_INVALID_ERROR = 'Please Enter integer  Value ';
export const QTY_ERROR = 'Please Enter Per  QTY ';
export const QTY_INVALID_ERROR = 'Please Enter Invalid QTY ';
// export const SEGEMENTSELECT_ERROR = 'Please Select Segment Selection';
// export const SEGEMENTSELECT_LEASTONE_ERROR = 'Please Select At Least One ';
export const NEW_PASSWORD_ERROR = 'Please Enter New Password ';
export const OLD_PASSWORD_ERROR = 'Please Enter Old Password ';
export const CONFIRM_PASSWORD_ERROR = 'Please Enter Confirm Password';
export const CONFIRM_AND_NEW_PASSWORD_ERROR = 'New Password And Confirm Password Are Not Matched';
export const OLD_AND_NEW_PASSWORD_ERROR = 'Old Password And New Password Are Not Matched';




// for add client
export const FROMDATE_ERROR = 'Select FromDate';
export const TODATEDATE_ERROR = 'Select ToDate';


//For Group Details

export const EMPTY_GROUP_NAME_ERR = 'Please Enter Group Name';
export const SEGEMENTSELECT_ERROR = 'Please Select Segment Selection';
export const SEGEMENTSELECT_LEASTONE_ERROR = 'Please Select At Least One ';


//  Strategy Error

export const EMPTY_STRATEGY_NAME_ERR = 'Please Enter Strategy Name';
export const EMPTY_STRATEGY_LOT_ERR = 'Please Enter Strategy Lot Amount ';
export const VALID_STRATEGY_LOT_ERR = 'Accept Number Only and Grater Than Zero';
export const EMPTY_STRATEGY_CATAGORY_ERR = 'Please Enter Strategy Category ';
export const EMPTY_STRATEGY_SEGMENT_ERR = 'Please Select Strategy Segment ';
export const EMPTY_STRATEGY_DESCRIPTION_ERR = 'Please Enter Strategy Description ';
export const EMPTY_MONTHLY_PLAN_ERR = 'Please Enter Monthly plan ';
export const EMPTY_QUATERLY_PLAN_ERR = 'Please Enter Quaterly plan ';
export const EMPTY_HALFYEARLY_PLAN_ERR = 'Please Enter halfyearly plan ';
export const EMPTY_YEARLY_PLAN_ERR = 'Please Enter yearly plan';
export const VALID_MONTHLY_PLAN_ERR = 'Accept Number Only and Grater Than Zero ';
export const VALID_QUATERLY_PLAN_ERR = 'Accept Number Only and Grater Than Zero';
export const VALID_HALFYEARLY_PLAN_ERR = 'Accept Number Only and Grater Than Zero';
export const VALID_YEARLY_PLAN_ERR = 'Accept Number Only and Grater Than Zero';



//  Update Theme
export const THEMESELECT_ERROR = 'Please Select Theme For Update';


// ForCompany Details

export const EMPTY_COMPANY_NAME_ERR = 'Please Enter Company Name';
export const EMPTY_SHORT_NAME_ERR = 'Please Enter Short  Name';
export const EMPTY_BROKER_NAME_ERR = 'Please Enter Broker Name';
export const EMPTY_VERSION_NAME_ERR = 'Please Enter Version  Name';
export const EMPTY_PANEL_KEY_ERR = 'Please Enter Panel Key  Name';




export const COMPANY_HOST_ERROR = 'Please Enter Valid SMTP HOST';
export const COMPANY_PORT_ERROR = 'Please Enter Valid SMTP PORT';
export const COMPANY_PASSWORD_ERROR = 'Please Enter Valid SMTP Password';
export const COMPANY_NAME_ERROR = 'Please Enter Valid Company Name';
export const EMPTY_COMPANY_EMAIL_ERROR = 'Please Enter  Valid  Company Email ';
export const INVALID_COMPANY_EMAIL_ERROR = 'please Enter A Valid Company Email ';
export const EMPTY_COMPANYCC_EMAIL_ERROR = 'Please Enter  Valid  Company CC Email ';
export const INVALID_COMPANYCC_EMAIL_ERROR = 'please Enter A Valid Company CC  Email ';
export const EMPTY_COMPANYBCC_EMAIL_ERROR = 'Please Enter  Valid  Company BCC Email ';
export const INVALID_COMPANYBCC_EMAIL_ERROR = 'please Enter A Valid Company BCC Email ';

//  For help

export const EMPTY_MSG_ERROR = 'Enter Your Message';


// FOR API CREATE INFO


export const EMPTY_API_CREATE_TITLE_ERROR = 'Enter Your Title';
export const EMPTY_API_CREATE_DESCRIPTION_ERROR = 'Enter Your Description';
export const INVALID_YOUTUBE_URL_ERROR = 'Enter Valid Youtube Url';




export const PANEL_NAME_ERROR = 'Enter Panel Name';
export const DOMAIN_ERROR = 'Enter Your Domain Name';
export const PORT_ERROR = 'Enter Valid Port';
export const KEY_ERROR = 'Enter Valid Key';
export const DBURL_ERROR = 'Enter Valid Data Base Url';
export const DBNAME_ERROR = 'Enter Valid Data Base NAme';
export const BACKNEDURL_ERROR = 'Enter Valid Backend Url';






